import { userSlice } from '@domagude/nospen-packages/frontend/redux/user/userSlice';

export type {
  LocationCoordinates,
  UserCurrentLocation,
  UserCurrentLocationPayload,
  UserIndicatorStats,
  UserLocation,
  UserState,
} from '@domagude/nospen-packages/frontend/redux/user/userSlice';

export { MESSAGES_INDICATOR_STATS_INITIAL_STATE } from '@domagude/nospen-packages/frontend/redux/user/userSlice';

export enum USER_LOCATION_PERMISSION {
  GRANTED = 'granted',
  DENIED = 'denied',
  PROMPT = 'prompt',
  PERMISSION_MODAL_WAS_CLOSED = 'permission_modal_was_closed',
}

export const {
  setUser,
  cleanUser,
  setCurrentUserLocation,
  setIsAuthModalOpen,
  setUserLocations,
  updateCurrentUserStats,
  updateUser,
  setUserIndicatorStats,
  updateUserIndicatorStats,
  incrementUnreadNotificationsCount,
  decrementExchangesUserIndicatorStatsCountIfNeeded,
  decrementUnreadMessagesUserIndicatorStatsCountIfNeeded,
} = userSlice.actions;

export default userSlice.reducer;
